export const isSearchTermValid = (term) =>
  !!(term && term.match(new RegExp("([^a-zA-z]|..+)", "gi")));

export const prepareSearchRegExp = (term) => {
  const escapeRegExp = (string) =>
    string
      .replace(/[.*+?^${}()|[\]\\]/g, "\\$&") // $& means the whole matched string
      .replace(/\s/g, "\\s+"); // Allow for multiple spaces between words in search term
  const cleanedTerm = escapeRegExp(term);
  return new RegExp(`(${cleanedTerm})`, "gi");
};

export const makeSearchRegExp = (term) =>
  isSearchTermValid(term) ? prepareSearchRegExp(term) : null;
